import React, { Fragment } from 'react';

const Stats = () => {
	return (
		<Fragment>
			<div className="stats">
				Millions of files compressed. Fast. Best algorithms. No Ads, spam or hidden adwares.
			</div>
		</Fragment>
	);
};

export default Stats;



// WEBPACK FOOTER //
// ./src/components/Stats.js